// Bulk-action UI for checkbox tables.
// Controls the visibility of the bulk-action submit button and the enabled state of the search form
// based on the checkbox selection state in the table.
//
// Usage: add the following data attributes to the element wrapping the table:
//   data-bulk-table        : attach to the element wrapping the target table to activate this script
//   data-checkbox          : CSS selector for the checkbox input in each row (e.g. ".student-checkbox")
//   data-controls          : CSS selector for the element containing the bulk-action button (e.g. "#bulk-controls")
//   data-search-form       : CSS selector for the search form to disable when checkboxes are checked (e.g. "#student-search-form")
//   data-select-all        : CSS selector for the select-all checkbox (e.g. "#select-all-students")
//
// Optional: any element inside data-controls carrying a data-confirm-template attribute gets its
// data-confirm rewritten whenever the selection changes, with "{count}" replaced by the number of
// checked rows. Keep a static data-confirm alongside it as the fallback for when this script does
// not run.
//
// see details: app/views/staff/school_classes/add_student.html.erb

document.addEventListener('turbolinks:load', function () {
  document.querySelectorAll('[data-bulk-table]').forEach(function (root) {
    const checkboxes = root.querySelectorAll(root.dataset.checkbox);
    const bulkControls = document.querySelector(root.dataset.controls);
    const searchForm = document.querySelector(root.dataset.searchForm);
    const selectAll = root.querySelector(root.dataset.selectAll);

    if (checkboxes.length === 0) return; // No checkboxes found, do nothing

    /**
     * @returns {number} the number of checked checkboxes
     */
    function checkedCount() {
      return Array.from(checkboxes).filter(cb => cb.checked).length;
    }

    /**
     * @returns {boolean} true if all checkboxes are checked
     */
    function allChecked() {
      return Array.from(checkboxes).every(cb => cb.checked);
    }

    function updateUI() {
      const count = checkedCount();
      const checked = count > 0;

      if (bulkControls) {
        bulkControls.classList.toggle('d-none', !checked); // show bulk controls if any checkbox is checked

        bulkControls.querySelectorAll('[data-confirm-template]').forEach(el => { // keep the confirm dialog in sync with the selection size
          el.dataset.confirm = el.dataset.confirmTemplate.replace('{count}', count);
        });
      }

      if (searchForm) {
        searchForm.querySelectorAll('input, button, a.btn').forEach(el => { // disable search form fields when any checkbox is checked
          el.disabled = checked;
          el.classList.toggle('disabled', checked);
        });
      }

      if (selectAll) {
        selectAll.disabled = false;
        selectAll.checked = allChecked();
      }
    }

    checkboxes.forEach(cb => cb.addEventListener('change', updateUI)); // Update UI when any checkbox state changes

    if (selectAll) {
      selectAll.addEventListener('change', function () {
        checkboxes.forEach(cb => { cb.checked = selectAll.checked; });
        updateUI();
      });
    }

    updateUI();
  });
});
